namespace Areas.Employee {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Employee", "Index", 
        ["Edit", "UCPath", "Contact", "Web", "Time", "TimeEntryNote", 
            "Jobs", "Licenses","Activity", "Accruals", "Attachment", "TimeEntryRights"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

}